<template>
<div class="item" :id="eid">
    <div class="item-container" v-if="options.country.selected">

        <!-- PANEL 1 -->
        <div class="item-panel">
            <div class="col-xs-12 title" v-if="graph1.hasData == 'yes'">
                <div class="row" v-if="enableCityFilter && enableStationFilter" style="margin-top: -8px; margin-bottom: -8px;">
                    <div class="col-xs-6" v-show="enableCityFilter">
                         <div class="btn btn-default btn-block btn-selector" @click="showCitySelector = true">{{ options.city.selected.name }}</div>
                    </div>
                    <div class="col-xs-6" v-show="enableStationFilter">
                        <div class="btn btn-default btn-block btn-selector" @click="showStationSelector = true">{{ options.station.selected.name }}</div>
                    </div>
                </div>

                <span v-else>{{getPeriod}} <u>{{filter}}</u> Evolution</span>
            </div>

            <div class="col-xs-12" v-if="graph1.hasData == 'yes'">
                <div class="graph-container fixed-graph">
                    <chart v-if="graph1.data.datasets.length > 3" :raw-data="graph1.data" :events="events" :song="song" :media="media" :chart-id="media + '-canvas-1'" :filter="filter" :period="period" :fill="false"></chart>
                    <bar-chart v-else :raw-data="graph1.data" :events="events" :song="song" :media="media" :chart-id="media + '-canvas-1'" :filter="filter" :period="period" :fill="false"></bar-chart>
                </div>
            </div>

            <div v-show="graph1.hasData == 'no'" class="panel-text">
                <p>
                    <i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br>
                    <span v-if="!country.code"><b>Not enough data</b><br>to generate the chart.</span>
                    <span v-if="country.code">No data available for <b>{{country.name}}</b><br>to generate the chart.</span>
                </p>
            </div>

            <loader v-if="graph1.hasData == 'pending'" color="ripple" size="150px" style="height: 280px;"></loader>
        </div>

        <!-- PANEL 2 -->
        <div class="item-panel" v-if="isExtended && hasDetailedAccess">
            <div class="col-xs-12 title" v-if="graph2.hasData == 'yes'">
                <div class="row" v-if="enableCityFilter && enableStationFilter && country.code" style="margin-top: -8px; margin-bottom: -8px;">
                    <div class="col-xs-6" v-show="enableCityFilter">
                         <div class="btn btn-default btn-block" @click="showCitySelector = true">{{ options.city.selected.name }}</div>
                    </div>
                    <div class="col-xs-6" v-show="enableStationFilter">
                        <div class="btn btn-default btn-block" @click="showStationSelector = true">{{ options.station.selected.name }}</div>
                    </div>
                </div>

                <span v-else>{{getPeriod}} <u>{{filter}}</u> Evolution</span>
            </div>        

            <div class="col-xs-12" v-show="graph2.hasData == 'yes'">
                <div class="graph-container">
                    <div class="graph-bar">
                        <chart-radio :media="media" :raw-data="graph2.data" :chart-id="media + '-canvas-2'"></chart-radio>
                    </div>
                </div>

                <div class="graph-axis">
                    <chart-radio :media="media" :raw-data="graph2.data" :chart-id="media + '-canvas-2'"></chart-radio> 
                </div>
            </div>

            <div v-show="graph2.hasData == 'no'" class="panel-text">
                <p><i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br><b>Not enough data</b><br>to generate the chart.</p>
            </div>

            <div class="col-xs-12" v-show="graph2.hasData == 'pending'">
                <loader color="ripple" size="150px" style="height: 280px;"></loader>
            </div>
        </div>

        <div class="item-panel" v-if="isExtended && !hasDetailedAccess">
            <div class="title"><span>PLAYS BY COUNTRY</span></div>

            <div class="permission" v-show="!hasPermission">
                <span class="iconify" data-icon="topcoat:lock" data-inline="false" data-height="100"></span>
                <br><br>
                <p style="white-space: initial;">In order to see this chart,<br> you have to <u>manually request</u> access to extended/detailed country statistics.</p>
                <br>
                <div class="button btn btn-default" @click="askDataPermission()">Request {{ isOwner ? 'SoundFeed' : song.uploader.name }}</div>
            </div>

            <div class="permission" style="padding-top: 50px;" v-show="hasPermission">
                <span class="iconify" data-icon="uil:file-info-alt" data-inline="false" data-height="90"></span><br><br>
                <br><p style="white-space: initial;">Your request for <b>detailed country statistics</b><br> has been submited !</p>
            </div>
        </div>

        <div class="item-panel" v-if="!isExtended">
            <div class="title"><span>PLAYS BY COUNTRY</span></div>

            <div class="panel-text m-t--32">
                <p><i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br>No data available for <b>{{getName}}</b><br>to generate the chart.</p>
            </div>
        </div>

        <div class="item-panel" style="display: none;">
            <div class="title"><span>Demographic statistics</span></div>

            <div class="audience row">
                <div class="male col-xs-6">
                    male audience<br>
                    <animated-number :value="graph3.audience" :duration="500" :formatValue="formatToProcent"/>
                </div>

                <div class="female col-xs-6">
                    female audience<br>
                    <animated-number :value="100 - graph3.audience" :duration="500" :formatValue="formatToProcent"/>
                </div>

                <div class="chart col-xs-12">
                    <div class="ratio">
                        <div></div>
                    </div>
                    <div class="average">
                        <span>AVG. AGE</span>
                        <h3><animated-number :value="graph3.age" :duration="500" :round="1"/></h3>
                    </div>
                </div>                 
            </div>
        </div>

        <div class="item-panel" style="display: none;">
            <div class="title"><span>Demographic statistics</span></div>

            <div class="col-xs-12 audience-graph">
                <div class="graph-bar-audience graph-left">
                    <chart-audience :type="'male'" :media="media" :raw-data="graph3.data" :chart-id="media + '-male-audience-canvas-3'"></chart-audience>
                </div>
                <div class="graph-bar-audience graph-right">
                    <chart-audience :type="'female'" :media="media" :raw-data="graph3.data" :chart-id="media + '-female-audience-canvas-3'"></chart-audience>
                </div>
            </div>
        </div>
    </div>

    <div class="paginator text-center" v-show="graphPage != -1">
        <span v-show="graphPage != 0"><i class="iconify icon:ic:round-brightness-1"></i></span>
        <span v-show="graphPage == 0"><i class="iconify icon:ic:round-brightness-1 active"></i></span>

        <span v-show="graphPage != 1"><i class="iconify icon:ic:round-brightness-1"></i></span>
        <span v-show="graphPage == 1"><i class="iconify icon:ic:round-brightness-1 active"></i></span>

<!--         <span v-show="graphPage != 2"><i class="iconify icon:ic:round-brightness-1"></i></span>
        <span v-show="graphPage == 2"><i class="iconify icon:ic:round-brightness-1 active"></i></span>

        <span v-show="graphPage != 3"><i class="iconify icon:ic:round-brightness-1"></i></span>
        <span v-show="graphPage == 3"><i class="iconify icon:ic:round-brightness-1 active"></i></span> -->
    </div>

    <div class="move-to-root">
        <transition name="page-overlay">
            <div class="page-overlay options" v-show="showCitySelector">
                <div class="container">
                    <div class="row" v-if="hasDetailedAccess">
                        <div class="head text-center">
                            <img src="/img/web/song/statistics/warm_music.svg">
                            <h2>Radio Stats</h2>
                        </div>                    
                        <div class="col-xs-12 content">
                            <h5 class="text-left">
                                <span>Choose city</span>
                                <span class="button button-center btn-sort" @click="sortOptions('city', 'numeric')" v-show="sortOptions('city') == 'alpha'">
                                    <i class="iconify icon:fa:sort-alpha-asc"></i>
                                </span>
                                <span class="button button-center btn-sort" @click="sortOptions('city', 'alpha')" v-show="sortOptions('city') == 'numeric'">
                                    <i class="iconify icon:fa:sort-numeric-desc"></i>
                                </span>
                            </h5>
                            <ul class="list list-sm">
                                <li v-for="option in options.city.values" class="button" @click="changeRadioFilter('city', option)" :class="{active: options.city.selected.code == option.code}">
                                    <span class="pull-left">{{ option.name }}</span>
                                    <span class="pull-right">{{ option.plays }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="row" v-else>
                        <div class="head text-center">
                            <img src="/img/web/song/statistics/warm_music.svg">
                            <h2>Radio Stats</h2>
                        </div>                    
                        <div class="col-xs-12 content">
                            <div class="access-required text-center" v-show="!hasPermission">
                                <span class="iconify" data-icon="topcoat:lock" data-inline="false" data-height="50"></span>
                                <br><br>
                                <p style="white-space: initial;">In order to see <b>CITY DATA</b>,<br> you have to first <u>request access</u> to extended/detailed country statistics.</p>
                                <br>
                                <div class="button btn btn-primary" @click="askDataPermission()">Request {{ isOwner ? 'SoundFeed' : song.uploader.name }}</div><br>
                                <div class="button btn btn-default m-t-6" @click="showCitySelector = false">BACK</div>
                            </div>

                            <div class="access-required text-center" v-show="hasPermission">
                                <span class="iconify" data-icon="uil:file-info-alt" data-inline="false" data-height="90"></span><br><br>
                                <br><p style="white-space: initial;">Your request for <b>detailed country statistics</b><br> has been submited !</p>
                                <div class="button btn btn-default m-t-6" @click="showCitySelector = false">BACK</div>
                            </div>                            
                        </div>
                    </div>                    
                </div>
            </div>
        </transition>

        <transition name="page-overlay">
            <div class="page-overlay options" v-show="showStationSelector">
                <div class="container">
                    <div class="row" v-if="hasDetailedAccess">
                        <div class="head text-center">
                            <img src="/img/web/song/statistics/warm_music.svg">
                            <h2>Radio Stats</h2>
                        </div>                    
                        <div class="col-xs-12 content">
                            <h5 class="text-left">
                                <span>Choose station</span>
                                <span class="button button-center btn-sort" @click="sortOptions('station', 'numeric')" v-show="sortOptions('station') == 'alpha'">
                                    <i class="iconify icon:fa:sort-alpha-asc"></i>
                                </span>
                                <span class="button button-center btn-sort" @click="sortOptions('station', 'alpha')" v-show="sortOptions('station') == 'numeric'">
                                    <i class="iconify icon:fa:sort-numeric-desc"></i>
                                </span>
                            </h5>
                            <ul class="list list-sm">
                                <li v-for="option in options.station.values" class="button" @click="changeRadioFilter('station', option)" :class="{active: options.station.selected.code == option.code}">
                                    <span class="pull-left">{{ option.name }}</span>
                                    <span class="pull-right">{{ option.plays }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="row" v-else>
                        <div class="head text-center">
                            <img src="/img/web/song/statistics/warm_music.svg">
                            <h2>Radio Stats</h2>
                        </div>                    
                        <div class="col-xs-12 content">
                            <div class="access-required text-center">
                                <span class="iconify" data-icon="topcoat:lock" data-inline="false" data-height="50"></span>
                                <br><br>
                                <p style="white-space: initial;">In order to see <b>STATION DATA</b>,<br> you have to first <u>request access</u> to extended/detailed country statistics.</p>
                                <br>
                                <div class="button btn btn-primary" @click="askDataPermission()">Request {{ isOwner ? 'SoundFeed' : song.uploader.name }}</div><br>
                                <div class="button btn btn-default m-t-6" @click="showStationSelector = false">BACK</div>
                            </div>
                        </div>
                    </div>                     
                </div>
            </div>                
        </transition>
    </div>

</div>
</template>

<script>
import AnimatedNumber from "animated-number-vue";
import Multiselect from 'vue-multiselect';
export default {
    props: ['song', 'media', 'period', 'filter', 'events',  'selected', 'country'],

    components: {
        AnimatedNumber,
        Multiselect,
        'chart': require('@/components/Song/Show/Tab/Statistics/Charts/Chart.vue').default,
        'bar-chart': require('@/components/Song/Show/Tab/Statistics/Charts/BarChart.vue').default,
        'chart-radio': require('@/components/Song/Show/Tab/Statistics/Charts/Chart-Radio.vue').default,
        'chart-audience': require('@/components/Song/Show/Tab/Statistics/Charts/Chart-Audience.vue').default,
        'loader': require('@/components/Loader.vue').default,
    },

    data() {
        return {
            eid: this.media +"_panel_"+ Math.random().toString(36).substr(2, 9),
            graphPage: false,
            permission: false,

            graph1: {
                data: null,
                rawData: {
                    datasets: null,
                    labels: null                        
                },
                hasData: 'pending',
            },

            graph2: {
                data: {datasets: [], labels: [], type: 'country'},
                hasData: 'pending',
                sort: false
            },

            graph3: {
                data: {
                    "male": {labels: [], datasets: []},
                    "female": {labels: [], datasets: []},
                },
                audience: 0,
                age: 0,
            },

            showCountrySelector: false,
            showCitySelector: false,
            showStationSelector: false,

            options: {
                'country': { values: [{ name: 'ALL Countries', code: 0 }], selected: false, sort: 'numeric' },
                'city': { values: [{ name: 'ALL Countries', code: 0 }], selected: { name: 'ALL Cities', code: 0 }, sort: 'numeric' },
                'station': { values: [{ name: 'ALL Stations', code: 0 }], selected: { name: 'ALL Stations', code: 0 }, sort: 'numeric' },
            },

            graphType: 'country',

            from: 0,
            to: 0,
        }
    },

    activated() {
        this.changeRadioFilter('country', this.country);
    },

    mounted() {
        $(".move-to-root").appendTo(".page-content");
        this.graphPage = 0;

        this.changeRadioFilter('country', this.country);

        this.$nextTick(() => {
            $(`#${this.eid} .item-container`).on('scroll', () =>{
                var sL = $(`#${this.eid} .item-container`).scrollLeft();
                var sW = $(`#${this.eid} .item-container`).width();
                this.graphPage = Math.round(sL / sW);
            });
        });
    },

    methods: {
        getData(graph){
            /// get time interval based on period
            this.to = moment().format('YYYY-MM-DD');

            switch (this.period){
                case 'year':   this.from = moment().subtract(1, 'year').format('YYYY-MM-DD'); break;
                case 'months': this.from = moment().subtract(3, 'months').format('YYYY-MM-DD'); break;
                case 'month':  this.from = moment().subtract(1, 'months').format('YYYY-MM-DD'); break;
                case 'week':   this.from = moment().subtract(7, 'days').format('YYYY-MM-DD'); break;
            }

            if (graph == 'graph1'){
                if (!this.country.code || this.isExtended){
                    this.$http.get(this.dataEndpoint).then((success) => {
                        this.graph1.rawData = success.data.data || success.data.results;

                        var hasLabels = typeof this[graph].rawData.labels !== 'undefined';
                        var hasDatasets = typeof this[graph].rawData.datasets !== 'undefined' && this[graph].rawData.datasets.reduce((a, b) => a + b, 0);

                        if (!hasLabels || !hasDatasets) {
                            this.graph1.hasData = 'no';
                            
                            //fill stuff with empty values
                            var date = new Date();
                            this[graph].rawData = {
                                datasets: [],
                                labels: []
                            }

                            for (var i = 0; i < 366; i++) {
                                this.graph1.rawData.datasets.push(null);
                                this.graph1.rawData.labels.push( moment(date.addDays(i - 366)).format("YYYY-MM-DD") );   
                            }                    
                        }else{
                            this.graph1.hasData = 'yes';
                        }

                        this.processData('graph1');
                    }, (error) => {
                        this.graph1.hasData = 'no';
                    });
                }else{
                    this.graph1.hasData = 'no';
                    this.processData('graph1');
                }
            }

            if (graph == 'graph2'){
                if (!this.isExtended){
                    this.graph2.hasData = 'no';
                    return;
                }

                // fetch dropdowns and barhart-graph
                if (this.enableCountryFilter && this.graphType == 'country'){
                    this.$http.get(this.countryEndpoint).then((success) => {
                        var response = success.data.data;
                        var data = {datasets: [], labels: [], type: 'country'}
                        this.options.country.selected = { name: 'ALL Countries', code: 0, plays: 'Plays' };
                        this.options.country.values = [this.options.country.selected];

                        $.each(response, (i, result) => {
                            this.options.country.values.push({name: result.country, code: result.code, plays: result.plays || result.views});
                            data.labels.push(result.country);
                            data.datasets.push(result.plays || result.views);
                        })

                        if (this.graphType == 'country'){
                            if (response && response.length){
                                var h = data.labels.length * 50 + 24;
                                $('#'+ this.media +'-canvas-2').closest('.graph-bar').css('height', h + 'px' );
                                $('#'+ this.media +'-canvas-2').closest('.graph-container').parent().find('.graph-axis').css('display', h > 300 ? 'block' : 'none');

                                this.graph2.data = data;
                                this.graph2.hasData  = 'yes';

                                this.sortCountries();
                                this.processData(graph);
                            }else{
                                this.graph2.hasData  = 'no';
                            }
                        }

                    }, (error) => { console.log(error); });
                }

                if (this.enableCityFilter && (this.graphType == 'country' || this.graphType == 'city')){
                    this.$http.get(this.cityEndpoint).then((success) => {
                        var response = success.data.data;
                        var data = {datasets: [], labels: [], type: 'city'}
                        this.options.city.values = [{ name: 'ALL Cities', code: 0, plays: 'Plays' }];

                        $.each(response, (i, result) => {
                            this.options.city.values.push({name: result.city, code: result.id, plays: result.plays || result.views});
                            data.labels.push(result.city);
                            data.datasets.push(result.plays || result.views);                    
                        })

                        if (this.graphType == 'city'){
                            if (response.length){
                                var h = data.labels.length * 50 + 24;
                                $('#'+ this.media +'-canvas-2').closest('.graph-bar').css('height', h + 'px' );
                                $('#'+ this.media +'-canvas-2').closest('.graph-container').parent().find('.graph-axis').css('display', h > 300 ? 'block' : 'none');

                                this.graph2.data = data;
                                this.graph2.hasData  = 'yes';
                                this.processData(graph);
                            }else{
                                this.graph2.hasData  = 'no';
                            }
                        }                
                    }, (error) => { console.log(error); });
                }

                if (this.enableStationFilter && (this.graphType == 'country' || this.graphType == 'city' || this.graphType == 'station')){
                    this.$http.get(this.stationEndpoint).then((success) => {
                        var response = success.data.data;
                        var data = {datasets: [], labels: [], type: 'station'}
                        this.options.station.values = [{ name: 'ALL Stations', code: 0, plays: 'Plays' }];

                        $.each(response, (i, result) => {
                            this.options.station.values.push({name: result.station, code: result.id, plays: result.plays});
                            data.labels.push(result.station);
                            data.datasets.push(result.plays);                     
                        })

                        if (this.graphType == 'station'){
                            if (response.length){
                                var h = data.labels.length * 50 + 24;
                                $('#'+ this.media +'-canvas-2').closest('.graph-bar').css('height', h + 'px' );
                                $('#'+ this.media +'-canvas-2').closest('.graph-container').parent().find('.graph-axis').css('display', h > 300 ? 'block' : 'none');

                                this.graph2.data = data;
                                this.graph2.hasData  = 'yes';
                                this.processData(graph);
                            }else{
                                this.graph2.hasData  = 'no';
                            }
                        }                
                    }, (error) => { console.log(error); });
                }
            }
        },

        processData(graph = 'graph1') {
            var N = 0;
            var datasets = [];
            var labels = [];
            var lastIndex = null;
            var currentIndex = null;
            var date = null;
            var updateEvolution = graph == ('graph' + (this.graphPage + 1));

            if (this[graph].hasData == 'no'){
                if (updateEvolution) this.$parent.$emit('evolution-update', this.media, [], false);
                return;                
            }

            if (graph == 'graph2'){
                if (updateEvolution) this.$parent.$emit('evolution-update', this.media, this.graph2.data.datasets, false);
                return;
            }

            switch(this.period) {
                case 'year': N = 365; break;
                case 'months': N = 90; break;
                case 'month': N = 30; break;
                case 'week': N = 7; break;
            }

            for (var i = 365 - N; i < 366 ; i++) { 
                date = new Date(this[graph].rawData.labels[i]);
                switch (this.filter) {
                    case 'daily': currentIndex = this[graph].rawData.labels[i]; break; 
                    case 'weekly': currentIndex = date.getWeek(); break;
                    case 'monthly': currentIndex = date.getMonth(); break;
                }

                if (lastIndex != currentIndex){
                    lastIndex = currentIndex;
                    datasets.push(0);
                    labels.push(this[graph].rawData.labels[i]);
                }

                datasets[datasets.length - 1] += this[graph].rawData.datasets[i];
            }
 
            if (updateEvolution) this.$parent.$emit('evolution-update', this.media, datasets, this[graph].rawData.views_sum);

            // remove last week/month, because we always reffere to last full week/month of data
            // if (this.filter != 'daily'){
            //     datasets.pop();
            //     labels.pop();
            // }

            // 1 point data ?
            if (datasets.length == 1){
                datasets = [null, datasets[0], null];
                labels = [moment(labels[0]).subtract(1, 'days').format('YYYY-MM-DD'), labels[0], moment(labels[0]).subtract(-1, 'days').format('YYYY-MM-DD')];
            }

            this[graph].data = {
                'datasets': datasets,
                'labels': labels
            }
        },

        sortOptions(type, order = false){
            if (!order){
                return this.options[type].sort;
            }

            this.options[type].sort = this.options[type].sort == 'alpha' ? 'numeric' : 'alpha';

            if (this.options[type].sort == 'numeric'){
                this.options[type].values.sort(function(a,b){
                    if (a.code == 0) return -1;
                    if (b.code == 0) return 1;                    
                    return b.plays - a.plays;
                });
            }else{
                this.options[type].values.sort((a, b) => {
                    if (a.code == 0) return -1;
                    if (b.code == 0) return 1; 

                    var aName = a.name.toLowerCase();
                    var bName = b.name.toLowerCase(); 
                    return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
                });
            }            
        },

        sortCountries(){
            if (!this.country.code) return;

            var data = $.extend(true, {}, this.graph2.data);
            var pos = data.labels.indexOf(this.country.name);

            if (pos > -1){
                data.datasets.unshift(data.datasets.splice(pos, 1)[0]);
                data.labels.unshift(data.labels.splice(pos, 1)[0]);
            }else{
                data.datasets.unshift(0);
                data.labels.unshift(this.country.name);
            }

            this.graph2.data = data;            
        },

        changeRadioFilter(type, option){
            if (type == 'country'){
                this.options.country.selected = option;
                this.options.city.selected = { name: 'ALL Cities', code: 0 };
                this.options.station.selected = { name: 'ALL Stations', code: 0 };

                this.graphType = this.options.country.selected.code && this.enableCityFilter ? 'city' : 'country';
                setTimeout(() => {
                    this.showCountrySelector = false;
                }, 350)
            }

            if (type == 'city'){
                this.options.city.selected = option;
                this.options.station.selected = { name: 'ALL Stations', code: 0 };

                this.graphType = this.options.city.selected.code ? 'station' : 'city';
                setTimeout(() => {
                    this.showCitySelector = false;    
                }, 350) 
            }

            if (type == 'station'){
                this.options.station.selected = option;

                this.graphType = 'none';
                setTimeout(() => {
                    this.showStationSelector = false;    
                }, 350) 
            }

            this.graph2.hasData = this.graph2.sort ? 'yes' : 'pending';
            this.getData('graph2');

            this.graph1.hasData = 'pending';
            this.getData('graph1');
        },

 
        askDataPermission(){
            this.$http.post(this.getAccessEndpoint).then((success) => {
                if (App.allowGtag) gtag('event', `request_stats_access`, {
                    'event_category' : 'song',
                    'event_label' : `Request detailed stats for ${ this.isOwner ? 'own' : 'other user'} song`
                });
            });

            this.$root.$emit('request-access');          
        },

        formatToProcent(value){
            return value.toFixed(1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") + `<small>%</small>`;
        },        
    },

    computed: {
        getName(){
            switch (this.media){
                case 'total_streams': return 'All Channels';
                case 'spotify_plays': return 'Spotify'; break;
                case 'spotify_playlists': return 'Spotify Playlists'; break;
                case 'warm_music': return 'Radio'; break;
                case 'apple_music': return 'Apple Music'; break;
                case 'shazam': return 'Shazam'; break;
                case 'soundcloud': return 'Soundcloud'; break;
                default: return this.media;
            }  
        },

        getPeriod(){
            switch (this.period){
                case 'year':   return 'All Time'; break;
                case 'months': return 'Last 3 Months'; break;
                case 'month':  return 'Last Month'; break;
                case 'week':   return 'Last Week'; break;
                case 'day':    return 'Yesterday'; break;
            }
        },

        dataEndpoint() {
            if (this.country.code || this.options.city.selected.code > 0 || this.options.station.selected.code > 0){
                var to = moment().format('YYYY-MM-DD');
                var from = moment().subtract(365, 'days').format('YYYY-MM-DD');

                var param = this.options.country.selected.code ? "&country_"+ (this.media == 'warm_music' ? 'id' : 'code') +"=" + this.options.country.selected.code : "";
                param = this.options.city.selected.code ? "&city_id=" + this.options.city.selected.code : param;
                param = this.options.station.selected.code ? "&station_id=" + this.options.station.selected.code : param;

                return App.restApi + `/api/song/${this.song.id}/stats/${this.media}/history-chart?from=${from}&until=${to}` + param;
            }else{
                return App.restApi + `/api/song/${this.song.id}/views/chart/${this.media}`;
            }
        },

        countryEndpoint() {
            return App.restApi + `/api/song/${this.song.id}/stats/${this.media}/countries?from=${this.from}&until=${this.to}`;
        },

        cityEndpoint() {
            var param = this.options.country.selected.code ? "&country_code=" + this.options.country.selected.code : "";
            return App.restApi + `/api/song/${this.song.id}/stats/${this.media}/cities?from=${this.from}&until=${this.to}` + param;
        },

        stationEndpoint() {
            var param1 = this.options.country.selected.code ? "&country_code=" + this.options.country.selected.code : "";
            var param2 = this.options.city.selected.code ? "&city_id=" + this.options.city.selected.code : "";
            return App.restApi + `/api/song/${this.song.id}/stats/${this.media}/stations?from=${this.from}&until=${this.to}` + param1 + param2;
        },

        getAccessEndpoint() {
            return App.restApi + '/api/song/'+ this.song.id +'/detailed-access';
        },

        enableCountryFilter(){
            var values = { 'youtube': true,  'warm_music': true, 'apple_music': true,  'spotify_plays': true  }; 
            return values[this.media];
        },

        enableCityFilter(){
            var values = { 'youtube': false, 'warm_music': true, 'apple_music': false, 'spotify_plays': false }; 
            return values[this.media];
        },

        enableStationFilter(){
            var values = { 'youtube': false, 'warm_music': true, 'apple_music': false, 'spotify_plays': false }; 
            return values[this.media];            
        },


        isOwner(){
            return App.user.id == this.song.uploader_id || App.user.id == 21;
        },

        hasPermission(){
            return this.song.permission;
        },

        hasDetailedAccess(){
            return App.user.id == 21 || (this.song.flags && this.song.flags.users_with_detailed_access && this.song.flags.users_with_detailed_access.indexOf(App.user.id) > -1);
        },

        allowedMedia(){
            return ["youtube", "soundcloud", "shazam", "spotify_plays", "warm_music", "apple_music"].indexOf(this.media) > -1;
        },

        isExtended(){
            return  ['soundcloud', 'shazam', 'spotify_playlists', 'total_streams'].indexOf(this.media) == -1 ;
        },

        maxPages(){
            return this.allowedMedia ? 3 : 1;
        },        
        
    },

    watch: {
        graphPage(){
            if (this.graphPage == 3){
                setTimeout(() => {
                    this.graph3.hasData = 'pending';
                    this.graph3.data = {
                        "male": {
                            labels: ["65+", "55 - 64", "45 - 54", "35 - 44", "25 - 34", "18 - 24"],
                            datasets:[
                                -Math.round(Math.random() * 10000 + 0),
                                -Math.round(Math.random() * 10000 + 3000),
                                -Math.round(Math.random() * 10000 + 6000),
                                -Math.round(Math.random() * 10000 + 9000),
                                -Math.round(Math.random() * 10000 + 12000),
                                -Math.round(Math.random() * 10000 + 15000),
                            ]
                        },
                        "female":{
                            labels: ["65+", "55 - 64", "45 - 54", "35 - 44", "25 - 34", "18 - 24"],
                            datasets:[
                                Math.round(Math.random() * 10000 + 0),
                                Math.round(Math.random() * 10000 + 3000),
                                Math.round(Math.random() * 10000 + 6000),
                                Math.round(Math.random() * 10000 + 9000),
                                Math.round(Math.random() * 10000 + 12000),
                                Math.round(Math.random() * 10000 + 15000),
                            ]
                        }
                    }
                }, 1000);
            }

            if (this.graphPage == 2){
                setTimeout(() => {
                    this.graph3.audience = Math.random() * 70 + 30; 
                    this.graph3.age = Math.random() * 50 + 12;
                    $('.audience .chart .ratio > div').css('transform', `rotate(-${1.8 * (100 - this.graph3.audience) }deg)`);
                }, 1000);
            }

            if (!this.hasDetailedAccess && this.graphPage > 0 || this.graphPage == -1) return;

            var g = 'graph' + (this.graphPage + 1);
            if (this[g].hasData == 'pending'){
                this.getData(g);
            }else{
                if (g == 'graph1') this.$nextTick(() => { this.processData('graph1'); });
                if (g == 'graph2') this.$nextTick(() => { this.processData('graph2'); });
            }

            if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                'page_path' : `/song/statistics/${this.media}/${g}`,
                'page_location': `/song/statistics/${this.media}/${g}`,
                'page_title' : `${ this.isOwner ? 'Own' : 'Other'} Song > Statistics > Youtube Views > Graph ${ this.graphPage + 1 }`,
            });             
        },

        period(){
            if (!this.hasDetailedAccess){
                if (this.graph1.hasData == 'yes') this.$nextTick(() => { this.processData('graph1'); });
            }else{
                if (this.graph1.hasData == 'yes') this.$nextTick(() => { this.processData('graph1'); });
                this.graph2.hasData = 'pending';
                this.graph2.sort = false; 
                this.getData('graph2');
            }
        },

        country(){
            this.changeRadioFilter('country', this.country);    
        },

        showCitySelector(){
            if (this.showCitySelector == false){
                setTimeout(() => {
                    $('.page-content').addClass('hasFooter');
                    this.$root.$emit('unlockScroll');

                    this.$nextTick(() => {
                        $('main').animate({ scrollTop: $('main').scrollTop() + $('#footer').height()}, 250);    
                    });
                }, 500);
            }else{
                $('.page-content').removeClass('hasFooter');
                this.$root.$emit('lockScroll');
            }
        },

        showStationSelector(){
            if (this.showStationSelector == false){
                setTimeout(() => {
                    $('.page-content').addClass('hasFooter');
                    this.$root.$emit('unlockScroll');

                    this.$nextTick(() => {
                        $('main').animate({ scrollTop: $('main').scrollTop() + $('#footer').height()}, 250);    
                    });
                }, 500);
            }else{
                $('.page-content').removeClass('hasFooter');
                this.$root.$emit('lockScroll');
            }
        },

        selected(){
            if (this.selected != this.media && this.graphPage > 0){
                this.graphPage = 0;
            }
        }
    },

    // beforeDestroy() {
    //     this.showCountrySelector = false;
    //     this.showCitySelector = false;
    //     this.showStationSelector = false;
    // }    
}
</script>